window.Zipify = window.Zipify || {};
window.Zipify.OCU = window.Zipify.OCU || {};
window.Zipify.OCU.api = window.Zipify.OCU.api || {};

window.Zipify.OCU.api.customCheckoutButton = '#UpcartPopup .upcart-checkout-button, .upcart-checkout-button';

function initUpcartTracking() {
  if (typeof window.upcartSubscribeCartLoaded === 'function') {
    
    window.upcartSubscribeCartLoaded((event) => {
      console.log('🛒 Upcart Loaded Event:', event.cart);
    });

    window.upcartSubscribeCartUpdated((event) => {
      console.log('🔄 Upcart Updated Event:', event.cart);
    });
    
  } else {
    requestAnimationFrame(initUpcartTracking);
  }
}

initUpcartTracking();